<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>User Management</el-breadcrumb-item>
                <el-breadcrumb-item>Users</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title">
                    User List
                </div>
            </el-col>
            <el-col :span="6" :offset="2" class="text-right">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="$router.push({ name: 'ManageUser'})">New User</el-button>
            </el-col>
        </el-row>

        <el-card  style="margin-top: 24px"  class="box-card">
            <div slot="header" class="clearfix">
                <span>Filter</span>
            </div>
            <el-row :gutter="8">
                <el-col :span="4" class="filter-space">
                    <el-input v-model="filter.staffId" size="small" placeholder="Staff ID" class="filter-item"/>
                </el-col>
                <el-col :span="4" class="filter-space">
                    <el-input v-model="filter.name" size="small" placeholder="Name" class="filter-item"/>
                </el-col>
                <el-col :span="4" class="filter-space">
                    <el-input v-model="filter.email" size="small" placeholder="Email Address" class="filter-item"/>
                </el-col>
                <el-col :span="4" class="filter-space">
                    <el-input v-model="filter.jobTitle" size="small" placeholder="Job Title" class="filter-item"/>
                </el-col>
                <el-col :span="4" class="filter-space">
                    <el-select
                            value-key="id"
                            v-model="filter.country"
                            filterable
                            remote
                            clearable
                            auto-complete="nope"
                            placeholder="Select Country"
                            :remote-method="searchCountry"
                            :loading="searchingCountry"
                            size="small"
                            @clear="searchCountry('')"
                            @change="searchCity('')">
                        <el-option
                                v-for="item in countries"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" class="filter-space">
                    <el-select
                            value-key="id"
                            v-model="filter.city"
                            filterable
                            remote
                            clearable
                            auto-complete="nope"
                            placeholder="Select City"
                            :remote-method="searchCity"
                            :loading="searchingCity"
                            size="small"
                            @clear="searchCity('')"
                            @change="searchOffice('')">
                        <el-option
                                v-for="item in cities"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" class="filter-space">
                    <el-select
                            value-key="id"
                            v-model="filter.office"
                            filterable
                            remote
                            clearable
                            auto-complete="nope"
                            placeholder="Select Office"
                            :remote-method="searchOffice"
                            :loading="searchingOffice"
                            @clear="searchOffice('')"
                            size="small">
                        <el-option
                                v-for="item in offices"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                
            </el-row>

            <el-button style="margin-top: 8px" @click="searchData" class="filter-item" size="small" type="primary" icon="el-icon-search">
                Search
            </el-button>
        </el-card>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" :gutter="15">
                        <el-col :span="4" :offset="16">
                            <status-filter v-model="query.status" @change="queryStatusChanged()"></status-filter>
                        </el-col>
                        <el-col :span="4">
                            <el-select
                                    v-model="hideCol"
                                    multiple
                                    collapse-tags
                                    placeholder="Hide Column"
                                    size="small">
                                <el-option
                                        v-for="item in showHideOpt"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-table
                            :data="users"
                            stripe
                            @sort-change="sortChange"
                            :default-sort="query.sort"
                            style="width: 100%">
                        <el-table-column
                                v-if="!hideCol.includes('staffId')"
                                prop="staffID"
                                label="staff ID"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('firstName')"
                                prop="firstName"
                                label="First Name"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('lastName')"
                                prop="lastName"
                                label="Last Name"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('email')"
                                prop="email"
                                label="Email Address"
                                width="180"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('country')"
                                prop="office.city.country.name"
                                label="Country"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('city')"
                                prop="office.city.name"
                                label="City"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('office')"
                                prop="office.name"
                                label="Office"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                v-if="!hideCol.includes('job')"
                                prop="jobTitle"
                                label="Job Title"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="active"
                                label="Status"
                                width="80">
                            <template slot-scope="scope">
                                {{scope.row.active ? 'Active' : 'Inactive'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="editUser(scope.row.id)"></el-button>
                                <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row.id)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="loadData" />
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="Remove User" :visible.sync="showDeleteUserDialog" >
            <div v-loading="deletingUser">
                <p style="word-break: normal">Remove user with id: <b>{{userIdToDelete}}</b>?</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDeleteUserDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="doDeleteUser()">Remove</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import api from "@/services/api/WRCService"
import Pagination from "@/components/Pagination"
import StatusFilter from '@/components/StatusFilter'

export default {
    components: { Pagination, StatusFilter },
    data: function() {
        return {
            users: [],
            countries: [],
            cities: [],
            offices: [],
            loading: false,
            searchingCountry: false,
            searchingCity: false,
            searchingOffice: false,
            showDeleteUserDialog: false,
            userIdToDelete: 0,
            deletingUser: false,
            query: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                status: 'Active',
                sort: {
                    prop: 'staffID',
                    order: 'ascending'
                }
            },
            filter: {
                staffId: null,
                name: null,
                email: null,
                jobTitle: null,
                country: null,
                city: null,
                office: null,
                status: null,
                sort: 'staffID',
                direction: 'ASC'
            },
            hideCol: [
                'country',
                'city',
                'office'
            ],
            showHideOpt: [
                {
                    label: "Staff ID",
                    value: "staffId"
                },
                {
                    label: "First Name",
                    value: "firstName"
                },
                {
                    label: "Last Name",
                    value: "lastName"
                },
                {
                    label: "Email",
                    value: "email"
                },
                {
                    label: "Country",
                    value: "country"
                },
                {
                    label: "City",
                    value: "city"
                },
                {
                    label: "Office",
                    value: "office"
                },
                {
                    label: "Job Title",
                    value: "job"
                }
            ]
        }
    },
    methods:{
        editUser : function(userId) {
            this.$router.push({ name: 'UserEdit', params: { userId } })
        },
        deleteUser : function(userId) {
            //this.$router.push({ name: 'UserEdit', params: { userId } })
            this.userIdToDelete = userId
            this.showDeleteUserDialog = true
        },
        doDeleteUser : function() {
            this.deletingUser = true;

            api.deleteUser(this.userIdToDelete).then(({ data }) => {

                this.$message({
                    message: 'Successfully removed user from user list.',
                    type: 'success'
                })

                this.loadData()
            }).catch(() => {}).then(() => {
                this.deletingUser = false
                this.showDeleteUserDialog = false
            });
        },
        searchData(){
            this.query.page = 1;
            this.loadData()
        },
        loadData() {
            this.loading = true;
            this.filter.page = this.query.page - 1;
            this.filter.limit = this.query.limit;

            var active = null

            if (this.query.status === "Active") {
                active = 1
            } else if (this.query.status === "Inactive") {
                active = 0
            }

            this.filter.status = active

            api.getUsers(this.filter).then(({ data }) => {
                this.query.total = data.data.pagination.totalRecords;
                this.users.splice(0, this.users.length);
                this.users.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        },
        queryStatusChanged() {
            this.searchData()
        },
        searchCountry(query) {
            this.searchingCountry = true;
            api.getCountries(query, {
                page: 0,
                size: 200
            }).then(({data}) => {
                this.countries.splice(0, this.countries.length);
                if(query === ''){
                    this.countries.push({
                        id: null,
                        name: 'Select Country'
                    })

                    this.filter.country = null;
                }
                this.countries.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.searchingCountry = false;
            });
        },
        searchCity(query) {
            this.filter.city = null;
            this.searchingCity = true;
            api.getCities({
                name: query,
                countryId: this.filter.country
            }, {
                page: 0,
                size: 100
            }).then(({data}) => {

                this.cities.splice(0, this.cities.length);
                if(query === '') {
                    this.cities.push({
                        id: null,
                        name: 'Select City'
                    });
                    this.filter.city = null;
                }
                this.cities.push(...data.data.items);

                this.searchOffice('');
            }).catch(() => {
            }).then(() => {
                this.searchingCity = false;
            });
        },
        searchOffice(query) {
            this.filter.office = null;
            this.searchingOffice = true;

            api.filterOffices(query, {
                page: 0,
                size: 100
            }, {
                cityId: this.filter.city,
                countryId: this.filter.country
            }).then(({ data }) => {

                this.offices.splice(0, this.offices.length);
                if(query === ''){
                    this.offices.push({
                        id: null,
                        name: 'Select Office'
                    });
                    this.filter.office = null;
                }
                this.offices.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.searchingOffice = false;
            });
        },
        sortChange(data) {
            const { prop, order } = data;
            if(prop == null){
                this.query.sort = {
                    prop: 'staffID',
                    order: 'ascending'
                };
            }else{
                this.query.sort = {
                    prop: prop,
                    order: order
                }
            }

            let direction = order === 'ascending' ? 'ASC':'DESC';
            this.filter.sort = prop;
            this.filter.direction = direction;
            this.loadData();
        },
    },
    mounted() {
        this.query.page = 1;
        this.loadData();
        this.searchCountry('');
        this.searchCity('');
        this.searchOffice('');
    }
}
</script>


<style scoped>
    .filter-space{
        margin-bottom: 5px;
        margin-top: 5px;
    }
</style>
